// Import the dashboard here for settings route
import Dashboard from "../../views/pages/dashboard/view.vue"; //
import LocationsTable from "../../views/pages/locations/view";
import PortRequestsTable from "../../views/pages/number-porting/view";

import layouts from "../../layout";
import UsersTable from "../../views/pages/users/view";
import BranchesTable from "../../views/pages/branches/view";
import CampaignsTable from "../../views/pages/10dlc/view"

export default [
  {
    path: "/locations",
    name: "locations",
    component: LocationsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["locations"],
      roles: [1, 3, 11, 12]
    }
  },
  {
    path: "/number-porting",
    name: "number-porting",
    component: PortRequestsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["number-porting"],
      roles: [1, 3, 11, 12]
    }
  },
  {
    path: "/users",
    name: "users",
    component: UsersTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["users"],
      roles: [1, 3, 11, 12]
    }
  },
  {
    path: "/settings",
    name: "settings",
    component: Dashboard,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["settings"],
      roles: [1, 3, 11, 12]
    }
  },
  {
    path: "/branches",
    name: "branches",
    component: BranchesTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["branches"],
      roles: [1, 3, 11, 12]
    }
  },
  {
    path: "/10dlc-messaging",
    name: "10dlc",
    component: CampaignsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["branches"],
      roles: [1,3, 11, 12]
    }
  }
];
